"use client";

import React, { useState, useEffect } from "react";
import { Label } from "semantic-ui-react";
import { fetchUserAttributes } from "aws-amplify/auth";
import { ButtonItem } from "../../../components/index.js";

export default function AddPhotosButton({ neighborhoodId, nhdetails }) {
  const [loggedin, setLoggedin] = useState(false);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        await fetchUserAttributes();
        setLoggedin(true);
      } catch (error) {
        setLoggedin(false);
      }
    };

    checkUserStatus();
  }, []);

  const handleAddPhotos = () => {
    if (loggedin) {
      if (nhdetails && nhdetails.length > 0) {
        localStorage.setItem("nhdetails", JSON.stringify(nhdetails));
      }

      localStorage.setItem(
        "neighborhoodId",
        neighborhoodId || "60e879f2-b1b0-4ce9-bb26-f06bb9631e98",
      );

      if (typeof window !== "undefined") {
        window.location.href = "/NhImages";
      }
    } else {
      if (typeof window !== "undefined") {
        localStorage.setItem("previous_url", window.location.href);
      }

      const signUpBtn = document.getElementById("sign_up_btn");
      if (signUpBtn) {
        signUpBtn.click();
      }
    }
  };

  return (
    <div className="add_photos" style={{ display: "inherit", width: "auto" }}>
      <ButtonItem
        as="div"
        labelPosition="right"
        floated="right"
        onClick={handleAddPhotos}
        className="theme_blue btn_blue"
      >
        <ButtonItem icon="camera retro" className="btn_blue_bg" />
        <Label
          as="a"
          name="saveNeighbor"
          content="Add Photos"
          basic
          pointing="left"
          onClick={handleAddPhotos}
          className="theme_blue btn_blue"
        />
      </ButtonItem>
    </div>
  );
}
